import Superslide from "superslide.js"
import { q, qq } from "../../helper/q"

export const menuMobile = () => {
  const menuForm = q(".menuForm")
  const myMenu = new Superslide({
    slider: q(".menuMobile"),
    content: q(".pageWrapper"),
    animation: "slideLeft",
    slideContent: true,
    allowContentInteraction: false,
    closeOnBlur: true,
    allowDrag: false,
    width: "80vw",
    beforeOpen: () => {
      menuForm.classList.add("menuFormActive")
    },
    beforeClose: () => {
      menuForm.classList.remove("menuFormActive")
    }
  })
  menuForm.addEventListener("click", () => {
    myMenu.toggle()
  })
  expandMenu()
}

const expandMenu = () => {
  const menuItems = qq(".menuMobileAdditionallyElement")
  menuItems.map(item => {
    const link = q(".menuMobileAdditionallyLink", item)
    link.addEventListener("click", e => {
      if (q("svg", link)) {
        e.preventDefault()
        link.parentNode.classList.toggle("menuMobileAdditionallyElementActive")
      } else {
        window.location.replace(link.href)
      }
    })
  })
}
